/* jshint esversion: 6 */
/* jshint ignore:start */
import axios from 'axios';
import { useEffect, useState, useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';
import { MyContext } from '../../Context/MyProvider';
import Slider from "react-slick";
import ImageLoad from './ImageLoad';
import { showToast } from '../../showTost';
import Lottie from 'lottie-react';
import SuccessLottie from "../../Lottie/Successfullysecounde.json";
import { useTranslation } from 'react-i18next';
import Payment from '../../PaymentGetaway/Payment';
import { uid } from 'uid';
import * as turf from '@turf/turf';
const CustomPrevArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="bg-white p-[7px] rounded-[50px] absolute z-10 right-[45px] -top-[30px] transform -translate-y-1/2 cursor-pointer">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.7501 12C21.7501 12.414 21.4141 12.75 21.0001 12.75H4.81115L10.5311 18.47C10.8241 18.763 10.8241 19.238 10.5311 19.531C10.3851 19.677 10.1931 19.751 10.0011 19.751C9.80909 19.751 9.61706 19.678 9.47106 19.531L2.47106 12.531C2.40206 12.462 2.3472 12.3791 2.3092 12.2871C2.2332 12.1041 2.2332 11.8971 2.3092 11.7141C2.3472 11.6221 2.40206 11.539 2.47106 11.47L9.47106 4.46999C9.76406 4.17699 10.2391 4.17699 10.5321 4.46999C10.8251 4.76299 10.8251 5.23803 10.5321 5.53103L4.81213 11.251H21.0001C21.4141 11.25 21.7501 11.586 21.7501 12Z" fill="#25314C" />
        </svg>
    </div>
);

const CustomNextArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="bg-white p-[7px] rounded-[50px] absolute z-10 right-[0px] -top-[30px] transform -translate-y-1/2 cursor-pointer">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.6919 12.2871C21.6539 12.3791 21.599 12.462 21.53 12.531L14.53 19.531C14.384 19.677 14.192 19.751 14 19.751C13.808 19.751 13.616 19.678 13.47 19.531C13.177 19.238 13.177 18.763 13.47 18.47L19.1899 12.75H3C2.586 12.75 2.25 12.414 2.25 12C2.25 11.586 2.586 11.25 3 11.25H19.189L13.469 5.53005C13.176 5.23705 13.176 4.76202 13.469 4.46902C13.762 4.17602 14.237 4.17602 14.53 4.46902L21.53 11.469C21.599 11.538 21.6539 11.6209 21.6919 11.7129C21.7679 11.8969 21.7679 12.1031 21.6919 12.2871Z" fill="#25314C" />
        </svg>
    </div>
);

const Checkout = () => {

    const { t } = useTranslation();
    const { BaseUrl, setIsShowAdsBox, AddressRef, selectads, setSelectAds, paymentloading, setPaymentLoading, paymentRes, setPaymentRes } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [itemlist, setItemList] = useState([]);
    const [datelist, setDateList] = useState([]);
    const [selectdate, setSelectDate] = useState("");
    const [timelist, setTimeList] = useState([]);
    const [copytimelist, setCopyTimeList] = useState([]);
    const [selecttime, setSelectTime] = useState("");
    const [selectaddonlist, setSelectAddonList] = useState([]);
    const [selectaddon, setSelectAddon] = useState([]);
    const [addontotal, setAddonTotal] = useState(0);
    const [itemtotal, setItemTotal] = useState(0);
    const [totalpay, setTotalPay] = useState(0);
    const [addonlist, setAddonList] = useState([]);
    const [isshow, setIsShow] = useState(false);
    const [addonprice, setAddonPrice] = useState(0);
    const [localdata, setLocalData] = useState([]);
    const [isadd, setIsAdd] = useState(false);
    const [extradata, setExtraData] = useState([]);
    const [showpayment, setShowPayment] = useState(false);
    const [bookingdata, setBookingData] = useState("");
    const [isDriverSelected, setIsDriverSelected] = useState(false);
    const [myWallet, setMyWallet] = useState(0);
    const [usedWallet, setUsedWallet] = useState(0);

    const [issuccess, setIsSuccess] = useState(false);

    const navigate = useNavigate();
    const Location = useLocation();

    if (Location.state) {
        var { path, name } = Location.state;
    }

    const Currency = secureLocalStorage.getItem("currency");
    const LocalData = secureLocalStorage.getItem("Productid");
    const { cid, title, pid } = JSON.parse(LocalData) || [];

    const settings = {
        dots: false,
        infinite: false,
        arrows: true,
        speed: 500,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        slidesToShow: 7,
        slidesToScroll: 1,
        responsive: [
            { breakpoint: 1445, settings: { slidesToShow: 6 }, },
            { breakpoint: 1310, settings: { slidesToShow: 5 }, },
            { breakpoint: 1145, settings: { slidesToShow: 4 }, },
            { breakpoint: 580, settings: { slidesToShow: 5 }, },
            { breakpoint: 430, settings: { slidesToShow: 4 }, },
        ],
    };

    useEffect(() => {

        setMyWallet(secureLocalStorage.getItem("wallet"));

        const localData = secureLocalStorage.getItem("Localdata");
        let matchData = [];
        let notMatchData = [];

        if (localData) {
            const jsonData = JSON.parse(localData);
            if (Array.isArray(jsonData)) {
                const matchedService = jsonData.find(item => item.service_id === cid);
                notMatchData = jsonData.filter(item => item.service_id !== cid);
                if (matchedService && Array.isArray(matchedService.cartdata)) {
                    matchData = matchedService.cartdata;
                }
            }
        }

        if (matchData.length <= 0) {
            navigate(-1);
        }

        setItemList(matchData);
        setLocalData(matchData);
        setExtraData(notMatchData);

        const LocalAddonList = secureLocalStorage.getItem("addonlist");
        if (LocalAddonList) {
            setSelectAddonList(JSON.parse(LocalAddonList));
            setSelectAddon(JSON.parse(LocalAddonList));
        }

        const PaymentRes = sessionStorage.getItem("Paymentstatus");

        if (PaymentRes) {
            if (PaymentRes === "PaymentDone") {
                setPaymentRes("PaymentDone");
            } else {
                setPaymentRes("PaymentFail");
            }
        }

        handleGetTimeSlot();
        handleGetAddon();

    }, []);

    useEffect(() => {
        const ItemTotal = itemlist.reduce((sum, item) => sum + item.allTotal, 0);
        const AddonTotal = selectaddonlist.reduce((sum, item) => sum + Number(item.price), 0);
        setItemTotal(ItemTotal);
        setAddonTotal(AddonTotal);
        setTotalPay(ItemTotal + AddonTotal);
    }, [itemlist, selectaddonlist]);

    useEffect(() => {
        const TotalPrice = selectaddon.reduce((sum, item) => sum + Number(item.price), 0);
        setAddonPrice(TotalPrice);
    }, [selectaddon]);

    useEffect(() => {
        if (!isadd) return;
        if (localdata.length >= 1) {
            const LocalCartData = [...extradata];
            const CartData = {
                service_id: cid,
                service_title: title,
                cartdata: localdata
            }
            LocalCartData.push({ ...CartData });
            secureLocalStorage.setItem("Localdata", JSON.stringify(LocalCartData));
            setIsAdd(false);
        } else {
            secureLocalStorage.removeItem("Localdata");
            navigate(-1);
        }
    }, [localdata]);

    useEffect(() => {
        if (!paymentRes) return;
        if (paymentRes === "PaymentDone") {
            handleBooking();
        } else {
            showToast({ title: t("Payment faild !!"), id: "error" });
            setPaymentRes("");
            setSelectDate("");
            setSelectTime("");
            setShowPayment(false);
            sessionStorage.removeItem("Paymentstatus");
            secureLocalStorage.removeItem("Bookingdata");
        }
    }, [paymentRes]);

    useEffect(() => {
        if (isDriverSelected) {
            if (totalpay > myWallet) {
                const Total = totalpay - myWallet;
                setTotalPay(Total);
                setUsedWallet(Number(myWallet));
                setMyWallet(0);
            } else {
                const Total = myWallet - totalpay;
                setMyWallet(Total);
                setTotalPay(0);
                setUsedWallet(totalpay);

            }
        } else {
            setMyWallet(secureLocalStorage.getItem("wallet"));
            setTotalPay(usedWallet + totalpay);
        }
    }, [isDriverSelected]);

    const handleGetTimeSlot = () => {
        const uid = secureLocalStorage.getItem("Userid") || "0";

        axios.post(`${BaseUrl}user_api/s_timeslot`, { uid, cid })
            .then((res) => {
                const { TimeslotData, AddressData } = res.data;
                setDateList(TimeslotData[0].days);
                handleSelectDate(TimeslotData[0].days[0], TimeslotData[0].tslot);
                setCopyTimeList(TimeslotData[0].tslot);
                setSelectAds(AddressData[0]);
                setTimeout(() => {
                    setLoading(false);
                }, 500);
            })
            .catch((error) => {
                console.error("s_timeslot", error);
            });
    }

    const handleSelectDate = (item, TimeList) => {
        setSelectDate(item);

        const CurrentDate = new Date()
        const dayName = CurrentDate.toLocaleDateString('en-US', { weekday: 'short' });
        const dayNumber = CurrentDate.getDate();
        const GetDate = `${dayName} ${dayNumber < 10 ? `0${dayNumber}` : dayNumber}`;

        if (item === GetDate) {

            const currentHours = CurrentDate.getHours();
            const currentMinutes = CurrentDate.getMinutes();
            const currentTimeDate = new Date();

            currentTimeDate.setHours(currentHours, currentMinutes, 0, 0);

            const filteredTimes = TimeList.filter(timeStr => {
                const time24 = new Date();
                const [time, modifier] = timeStr.split(" ");
                let [hours, minutes] = time.split(":").map(Number);

                if (modifier.toLowerCase() === "pm" && hours !== 12) {
                    hours += 12;
                } else if (modifier.toLowerCase() === "am" && hours === 12) {
                    hours = 0;
                }
                time24.setHours(hours, minutes, 0, 0);
                return time24 >= currentTimeDate;
            });

            setTimeList(filteredTimes);
            setSelectTime(filteredTimes[0]);
        } else {
            setSelectTime(copytimelist[0]);
            setTimeList(copytimelist);
        }
    }

    const handleNavigate = () => {
        navigate(path, { state: { path: "/", name: "Home" } });
    }

    const handleGetAddon = () => {

        const uid = secureLocalStorage.getItem("Userid") || "0";

        axios.post(`${BaseUrl}user_api/list_addon`, { uid, cid })
            .then((res) => {
                setAddonList(res.data.Addondata);
            })
            .catch((error) => {
                console.error("list_addon", error);
            });
    }

    const handleGetPrice = (item) => {
        return item.cost - (item.discount / 100) * item.cost;
    }

    const handleAddAddon = () => {
        if (selectaddon.length <= 0) {
            showToast({ title: t("Please select services !!"), id: "info" });
            return;
        }

        secureLocalStorage.setItem("addonlist", JSON.stringify(selectaddon));
        setSelectAddonList(selectaddon);
        setIsShow(false);
    }

    const handleChangeAds = () => {
        setIsShowAdsBox(true);
        setTimeout(() => {
            AddressRef.current.classList.add('addres_menu_open');
        }, 100);
    }

    const handleIncrement = (data) => {

        const FilterData = itemlist.map(list => {
            if (list.id === data.id) {
                if (data.service_mqty == list.qty) {
                    showToast({ title: t("ReachOut max quantity !!"), id: "info" });
                    return list;
                }
                const Qty = list.qty + 1;
                const allTotal = handleGetPrice(list) * Qty
                return { ...list, qty: Qty, allTotal };
            }
            return list;
        });

        const LocalFilter = localdata.map(item => {
            if (item.id === data.id) {
                if (data.service_mqty == item.qty) {
                    return item;
                }
                const qty = item.qty + 1;
                const allTotal = handleGetPrice(item) * qty;
                return { ...item, qty, allTotal };
            }
            return item;
        });

        setIsAdd(true);
        setLocalData(LocalFilter);
        setItemList(FilterData);
    }

    const handleDencrement = (data) => {
        const FilterData = itemlist.map(list => {
            if (list.id === data.id) {
                const allTotal = list.allTotal - handleGetPrice(list);
                const qty = list.qty - 1;
                if (qty === 0) return null;
                return { ...list, qty, allTotal };
            }
            return list;
        }).filter(Boolean);

        const LocalFilter = localdata.map(item => {
            if (item.id === data.id) {
                const allTotal = item.allTotal - handleGetPrice(item);
                const qty = item.qty - 1;
                if (qty === 0) return null;
                return { ...item, qty, allTotal };
            }
            return item;
        }).filter(Boolean);

        setIsAdd(true);
        setLocalData(LocalFilter);
        setItemList(FilterData);
    }

    const handleProceedToPay = () => {

        const uid = secureLocalStorage.getItem("Userid");

        if (!uid) {
            navigate("/Login");
            return;
        }

        if (!selectdate || !selecttime) {
            showToast({ title: t("Please select date and time !!"), id: "info" });
            return;
        }

        if (!selectads) {
            showToast({ title: t("Please select address !!"), id: "info" });
            return;
        }

        const Coordinates = secureLocalStorage.getItem("coordinates");

        if (Coordinates) {
            const zones = JSON.parse(Coordinates);
            const userPoint = turf.point([selectads.lat_map, selectads.long_map]);
            let isInsideAnyZone = false;
            let matchedZone = null;
            for (const zone of zones) {
                const coords = zone.coordinates.map(p => [p.lng, p.lat]);
                const polygon = turf.polygon([coords]);
                const inside = turf.booleanPointInPolygon(userPoint, polygon);
                if (inside) {
                    isInsideAnyZone = true;
                    matchedZone = zone;
                    break;
                }
            }
        }

        const BookingData = {
            uid,
            cid,
            full_address: `${selectads.hno}, ${selectads.landmark}, ${selectads.address}`,
            lat: selectads.lat_map,
            longs: selectads.long_map,
            time: selecttime,
            date: selectdate,
            product_total: String(totalpay),
            wal_amt: isDriverSelected ? usedWallet : "0",
            add_on: selectaddonlist.map(item => item.title),
            add_per_price: selectaddonlist.map(item => item.price),
            pid,
            ProductData: handleProductGet(),
            zone_id: secureLocalStorage.getItem("zone_id")
        }

        setBookingData(BookingData);

        if (totalpay == 0) {
            secureLocalStorage.setItem("Bookingdata", JSON.stringify({ ...BookingData, p_method_id: "5" }));
            sessionStorage.setItem("transactionid", "0");
            handleBooking();
            return;
        }

        setShowPayment(true);
        secureLocalStorage.setItem("page", "/checkout");
    }

    const handleProductGet = () => {
        const FilterData = itemlist.map(item => {
            return { title: item.title, cost: item.cost, service_id: item?.service_id, qty: item.qty, discount: item.discount }
        });
        return FilterData;
    }

    const handleBooking = () => {

        const transaction_id = sessionStorage.getItem("transactionid") || uid(10);
        const LocalData = secureLocalStorage.getItem("Bookingdata");

        if (LocalData) {
            const BookingData = JSON.parse(LocalData);

            axios.post(`${BaseUrl}user_api/s_order_now`, { ...BookingData, transaction_id })
                .then((res) => {
                    const Toastid = res.data.ResponseCode === "200" ? "success" : "error";
                    showToast({ title: res.data.ResponseMsg, id: Toastid });
                    if (res.data.ResponseCode === "200") {
                        sessionStorage.removeItem("transactionid");
                        sessionStorage.removeItem("Paymentstatus");
                        secureLocalStorage.removeItem("Bookingdata");
                        if (extradata.length >= 1) {
                            secureLocalStorage.setItem("Localdata", JSON.stringify(extradata));
                        } else {
                            secureLocalStorage.removeItem("Localdata");
                        }
                        setPaymentRes("");
                        setSelectDate("");
                        setSelectTime("");
                        setShowPayment(false);
                        setIsSuccess(true);
                    }
                    setPaymentLoading(false);
                })
                .catch((error) => {
                    console.error("s_order_now", error);
                });
        }
    }

    return (
        <div className="checkout_page">
            {loading
                ? <div className="w-full h-[calc(100vh-85px)] bg-white z-[777] fixed flex items-center justify-center">
                    <div className="loader"></div>
                </div>
                :
                <div className="width_container">

                    <div className="py-[20px] bg-white sticky top-[85px] z-[666] max-_430_:hidden">
                        <div className="flex items-center justify-between max-_430_:hidden">
                            <div className="border-[2px] rounded-[50px] px-[15px] py-[3px] cursor-pointer hover:bg-gray-800 group">
                                <Link className="flex items-center gap-[8px] group-hover:text-white" to="/" data-discover="true">
                                    <svg width="10" height="12" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5.35401 8.64601C5.54901 8.84101 5.54901 9.15804 5.35401 9.35304C5.25601 9.45104 5.12801 9.49903 5.00001 9.49903C4.87201 9.49903 4.74401 9.45004 4.64601 9.35304L0.646006 5.35304C0.451006 5.15804 0.451006 4.84101 0.646006 4.64601L4.64601 0.646006C4.84101 0.451006 5.15804 0.451006 5.35304 0.646006C5.54804 0.841006 5.54804 1.15804 5.35304 1.35304L1.70704 4.99903L5.35401 8.64601Z" fill="currentColor"></path>
                                    </svg>
                                    <h1 className="font-bold">{t("Home")}</h1>
                                </Link>
                            </div>
                            <div className="flex items-center gap-[10px] font-[500]">
                                <button onClick={handleNavigate} className="text-gray-600">{name || t("Home")}</button>
                                <svg width="10" height="12" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.35401 5.35401L1.35401 9.35401C1.25601 9.45201 1.12801 9.50001 1.00001 9.50001C0.87201 9.50001 0.744006 9.45101 0.646006 9.35401C0.451006 9.15901 0.451006 8.84198 0.646006 8.64698L4.292 5.00099L0.646006 1.35499C0.451006 1.15999 0.451006 0.842959 0.646006 0.647959C0.841006 0.452959 1.15804 0.452959 1.35304 0.647959L5.35304 4.64796C5.54904 4.84196 5.54901 5.15801 5.35401 5.35401Z" fill="#25314C"></path>
                                </svg>
                                <h1 className="text-gray-400">{t("Checkout")}</h1>
                            </div>
                        </div>
                    </div>

                    <div className="grid grid-cols-12 gap-[50px] mt-[20px]">

                        <div className="col-span-7 max-_1145_:col-span-12 section_1">
                            <div>
                                <h1 className="title">{t("Select Date Of Service")} :</h1>
                                <div className="mt-[15px]">
                                    <div className="slider-container">
                                        <Slider {...settings}>
                                            {datelist.map((item, index) => {
                                                const IsSelected = item === selectdate;
                                                return <div key={index} onClick={() => handleSelectDate(item, copytimelist)} className={`date_box ${IsSelected && "date_selected"}`}>
                                                    <h1 className="font-[600]">{item.split(" ")[1]}</h1>
                                                    <p>{item.split(" ")[0]}</p>
                                                </div>
                                            })}
                                        </Slider>
                                    </div>
                                </div>
                            </div>

                            <div className="mt-[20px]">
                                <h1 className="title">{t("Select Time Of Service")} :</h1>
                                <div className="flex flex-wrap items-center gap-[15px] mt-[15px]">
                                    {timelist.length >= 1
                                        ? timelist.map((item, index) => {
                                            const IsSeleted = item === selecttime;
                                            return <div key={index} onClick={() => setSelectTime(item)} className={`time_box ${IsSeleted && "time_selected"}`}>
                                                <h1 className="font-[500] ">{item}</h1>
                                            </div>
                                        })
                                        : <div className="h-[200px] bg-white w-full flex items-center justify-center rounded-[10px]">
                                            <h1 className="font-[600] text-[17px] text-gray-500">{t("No time available !!")}</h1>
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className="mt-[20px]">
                                <div className="flex items-center gap-[10px] justify-between">
                                    <h1 className="title">{t("Select Address")} :</h1>
                                    <button onClick={handleChangeAds} className="font-[600]">{selectads && t("Change address")}</button>
                                </div>

                                {selectads
                                    ? <div className="select_ads">
                                        <div className="flex items-center gap-[10px]">
                                            <div className="icon">
                                                <ImageLoad BaseUrl={BaseUrl} url={selectads?.address_image} CustomeStyle={"w-[20px]"} />
                                            </div>
                                            <div className="leading-5">
                                                <h1 className="font-[600] text-[17px] text-[--color]">{selectads?.type}</h1>
                                                <p className="text-[rgba(2,6,12,.6)] font-[500] text-[15px] leading-4">{selectads?.hno}, {selectads?.landmark}, {selectads?.address}</p>
                                            </div>
                                        </div>
                                    </div>
                                    : <div className="h-[100px] bg-white rounded-[10px] mt-[10px] flex items-center justify-center">
                                        <h1 onClick={handleChangeAds} className="font-[600] text-[18px] text-gray-600 cursor-pointer">Add Address</h1>
                                    </div>
                                }
                            </div>

                        </div>

                        <div className="col-span-5 max-_1145_:col-span-12 section_2">

                            <div>
                                <h1 className="font-[600] text-[17px] mb-[5px]">{t("Product list")} :</h1>
                                {itemlist.map((item, index) => {
                                    return <div key={index} className="product_box">
                                        <div>
                                            <h1 className="font-[500]">{item.title}</h1>
                                            <div className="flex items-center gap-[10px] text-[15px]">
                                                <h1>{t("Total")} : </h1>
                                                <p>{Currency}{handleGetPrice(item)}</p>
                                                <span className="line-through text-gray-600">{Currency + item.cost}</span>
                                            </div>
                                            <h1 className="text-[15px]">{t("Discount")} : {item.discount}%</h1>
                                        </div>
                                        <div className="">
                                            <div className="add_btn">
                                                <button onClick={() => handleDencrement(item)}>-</button>
                                                <span className="py-[5px]">{item.qty}</span>
                                                <button onClick={() => handleIncrement(item)}>+</button>
                                            </div>
                                        </div>
                                    </div>
                                })}
                            </div>

                            {secureLocalStorage.getItem("wallet") != 0 && <div className="border-[1px] border-gray-300 rounded-[10px] py-[10px] px-[20px] mt-[20px]">
                                <div className="flex items-center justify-between mb-[10px]">
                                    <h1 className='font-[500] text-[17px]'>{t("Pay from Wallet")}</h1>
                                    <label className="switch">
                                        <input type="checkbox" checked={isDriverSelected} onChange={() => setIsDriverSelected(!isDriverSelected)} />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                                <div className="border-[1px] border-[#8080803b] p-[10px] rounded-[10px] flex items-center justify-between">
                                    <div className="flex items-center gap-[5px]">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M18.75 6.297V6C18.75 3.582 17.418 2.25 15 2.25H5C3.483 2.25 2.25 3.483 2.25 5V18C2.25 20.418 3.582 21.75 6 21.75H18C20.418 21.75 21.75 20.418 21.75 18V10C21.75 7.845 20.692 6.553 18.75 6.297ZM20.25 15.75H16.5C15.535 15.75 14.75 14.965 14.75 14C14.75 13.035 15.535 12.25 16.5 12.25H20.25V15.75ZM5 3.75H15C16.577 3.75 17.25 4.423 17.25 6V6.25H5C4.311 6.25 3.75 5.689 3.75 5C3.75 4.311 4.311 3.75 5 3.75ZM18 20.25H6C4.423 20.25 3.75 19.577 3.75 18V7.44897C4.125 7.64097 4.55 7.75 5 7.75H18C19.577 7.75 20.25 8.423 20.25 10V10.75H16.5C14.708 10.75 13.25 12.208 13.25 14C13.25 15.792 14.708 17.25 16.5 17.25H20.25V18C20.25 19.577 19.577 20.25 18 20.25ZM17.01 13H17.02C17.573 13 18.02 13.448 18.02 14C18.02 14.552 17.573 15 17.02 15C16.468 15 16.015 14.552 16.015 14C16.015 13.448 16.458 13 17.01 13Z" fill="#25314C" />
                                        </svg>
                                        <h1 className='font-[500] text-[16px]'>{t("My Wallet")}</h1>
                                    </div>
                                    <h1 className='font-[500] text-[17px] text-[#682afb]'>{Currency}{myWallet}</h1>
                                </div>
                            </div>}

                            {addontotal !== 0 && <div className="mt-[15px]">
                                <h1 className="font-[600] text-[17px]">{t("Addon List")} :</h1>

                                <div className="mt-[5px] bg-white py-[5px] px-[10px] rounded-[10px] border-[1px]">
                                    {selectaddonlist.map((item, index) => {
                                        if (item.price !== "0") {
                                            return <div key={index} className="addon_box">
                                                <h1>{item.title}</h1>
                                                <span>{Currency + item.price}</span>
                                            </div>
                                        }
                                    })}
                                </div>
                            </div>}

                            <div className="mt-[15px]">
                                <h1 className="font-[600] text-[17px] mb-[5px]">{t("Bill Summary")} :</h1>

                                <div className="bg-white px-[10px] py-[2px] rounded-[10px] border-[1px]">

                                    <div className="flex items-center justify-between gap-[10px] py-[3px] font-[500] text-[rgb(49,49,49)]">
                                        <h1>{t("Item total")}</h1>
                                        <span>{Currency + itemtotal}</span>
                                    </div>

                                    {addontotal !== 0 && <div className="flex items-center justify-between gap-[10px] py-[3px] font-[500] text-[rgb(49,49,49)]">
                                        <h1>{t("Addon Item total")}</h1>
                                        <span>{Currency + addontotal}</span>
                                    </div>}

                                    {isDriverSelected && <div className="flex items-center justify-between gap-[10px] py-[3px] font-[500] text-[rgb(49,49,49)]">
                                        <h1>{t("Wallet Amount")}</h1>
                                        <span>-{Currency + usedWallet}</span>
                                    </div>}

                                    <div className="border-b-[2px] border-dashed mt-[5px]"></div>

                                    <div className="flex mt-[5px] items-center justify-between gap-[10px] py-[3px] font-[500]">
                                        <h1>{t("Total pay")}</h1>
                                        <span>{Currency + totalpay}</span>
                                    </div>

                                </div>
                            </div>

                            <div className="flex items-center gap-[15px] mt-[10px]">
                                <button onClick={() => setIsShow(true)} className="button bg-[--bgcolor] rounded-[10px]">{t("Edit service")}</button>
                                <button onClick={handleProceedToPay} className="button bg-[--color] rounded-[10px]">{t("Proceed to pay")}</button>
                            </div>

                        </div>

                    </div>

                </div>}

            {isshow && <div onClick={() => setIsShow(false)} className="model items-center">
                <div className="details_page">
                    <div onClick={(e) => e.stopPropagation()} className="addon_box">

                        <div className="p-[20px]">
                            <div className="border-b-[1px] border-black pb-[10px]">
                                <p className="font-bold text-[22px] text-gray-800">{t("Customise your service")}</p>
                            </div>
                        </div>

                        <div className="h-full scroll_container">
                            <div className="bg-white mx-[20px] mb-[20px] p-[10px] rounded-[10px]">
                                {addonlist?.map((item, index) => {
                                    return <AddonItem key={index} item={item} currency={Currency} setSelectAddon={setSelectAddon} selectaddon={selectaddon} />
                                })}
                            </div>
                        </div>

                        <div className="p-[20px] bg-white">

                            <div className="flex items-center justify-between gap-[10px]">
                                <div className="leading-[15px]">
                                    <h1 className="font-[500] text-[16px]">{t("Total Price")}</h1>
                                    <p className="font-bold">{Currency}{addonprice}</p>
                                </div>

                                <div style={{ width: "200px" }}>
                                    <button onClick={handleAddAddon} className="w-full py-[8px] rounded-[10px] text-white font-bold bg-[--bgcolor]">{t("ADD TO CART")}</button>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>
            </div>}

            {showpayment && <div onClick={() => !paymentloading && setShowPayment(false)} className="model items-end">
                <div onClick={(e) => e.stopPropagation()} className="bg-white w-[450px] rounded-t-[10px]">
                    <Payment totalpay={totalpay} BookingData={bookingdata} isshow={"0"} PageIndex={"0"} />
                </div>
            </div>}

            {issuccess && <div className="model items-center">
                <div className="success_box">
                    <Lottie
                        className="w-[250px] mx-auto mb-[20px] max-_430_:w-[200px]"
                        animationData={SuccessLottie}
                        loop={true}
                    />
                    <h1 className="font-bold text-[18px]">{t("Thank you for using our service")}</h1>
                    <p className="font-[500] text-[15px] text-gray-500 leading-4 mt-[10px] mb-[20px]">{t("Your service has been booked successfully.")} <br /> {t("Our team will reach out to you soon.")}</p>
                    <button onClick={() => navigate("/bookings")} className="button bg-[--bgcolor] rounded-[10px]">{t("Continue")}</button>
                </div>
            </div>}

        </div>
    )
}

export default Checkout

const AddonItem = ({ item, currency, setSelectAddon, selectaddon }) => {

    const isselect = selectaddon.some(addon => addon.title === item.title);

    const handleAddonAdd = () => {
        if (isselect) {
            const RemoveAddon = selectaddon.filter(addon => addon.title !== item.title);
            setSelectAddon(RemoveAddon);
        } else {
            setSelectAddon(prev => [...prev, item]);
        }
    }

    return (
        <div onClick={handleAddonAdd} className="py-[5px] cursor-pointer flex items-center justify-between gap-[10px]">
            <h1 className="text-gray-800 whitespace-nowrap overflow-hidden overflow-ellipsis">{item.title}</h1>
            <div className="flex items-center gap-[5px]">
                <p className="text-gray-800 text-[15px]">{currency}{item.price}</p>
                <div className={`${isselect ? "border-[--bgcolor] bg-[--bgcolor]" : "border-gray-500"} border-[2px] rounded-[5px]`}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 17.75C8.999 17.75 8.99799 17.75 8.99699 17.75C8.79699 17.749 8.60599 17.669 8.46499 17.526L4.46499 13.464C4.17399 13.169 4.178 12.694 4.473 12.403C4.768 12.113 5.24399 12.116 5.53399 12.411L9.003 15.935L18.469 6.46902C18.762 6.17602 19.237 6.17602 19.53 6.46902C19.823 6.76202 19.823 7.23705 19.53 7.53005L9.53 17.5301C9.39 17.6711 9.199 17.75 9 17.75Z" fill="white"></path>
                    </svg>
                </div>
            </div>
        </div>
    )
}

/* jshint ignore:end */